import { action, runInAction, observable } from 'mobx';
import { ErrorInterface } from 'modules/core/api/globalApi';
import priceController from './priceController';
import {
  PricesCalculateStationTireFittingRequest,
  PricesCalculateStationTireStorageRequest,
  PriceResponse,
} from '../api/priceCalculateApi';

export interface PriceCalculateStore {
  loading: boolean,
  error: ErrorInterface,
  pricesCalculateStationTireFittingResponse: PriceResponse,
  pricesCalculateStationTireFittingRequest: PricesCalculateStationTireFittingRequest,
}

const initialValues: PriceCalculateStore = {
  loading: false,
  error: null,
  pricesCalculateStationTireFittingResponse: null,
  pricesCalculateStationTireFittingRequest: null,
};
export const priceCalculateStore = observable(initialValues);

export const priceCalculateActions = {

  getPricesCalculateStationTireFittingResponse: action(async (request :PricesCalculateStationTireFittingRequest) => {
    priceCalculateActions.clearError();
    priceCalculateStore.loading = true;
    priceCalculateStore.pricesCalculateStationTireFittingRequest = request;
    const response = await priceController.getPricesCalculateStationTireFitting(request);
    priceCalculateActions.handleError(response);
    runInAction(() => {
      priceCalculateStore.pricesCalculateStationTireFittingResponse = response.data;
      priceCalculateStore.loading = false;
    });
  }),

  returnPricesCalculateStationTireFittingResponse: async (request :PricesCalculateStationTireFittingRequest) => {
    const response = await priceController.getPricesCalculateStationTireFitting(request);
    return response;
  },

  returnPricesCalculateStorageResponse: async (request :PricesCalculateStationTireStorageRequest) => {
    const response = await priceController.getPricesCalculateStationStorageFitting(request);
    return response;
  },

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      priceCalculateStore.error = errorData;
      priceCalculateStore.loading = false;
      throw errorData;
    }
  }),

  handleErrorWithoutThrow: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      priceCalculateStore.loading = false;
      priceCalculateStore.error = errorData;
    }
  }),

  async clearError() {
    try {
      runInAction(() => {
        priceCalculateStore.error = null;
        priceCalculateStore.loading = false;
      });
    } catch (err) {
      this.handleError(err);
    }
  },
};
